<template>
  <div>
    <div class="row mx-auto col-12">
      <icon-view
        class="mt-md-0 mt-sm-5 icon-font-22"
        gradient
        icon="fas fa-user-tie mb-1"
        icon-color="#ff7058"
        icon-size="20px"
        title="Detalle Muestra"
      />
    </div>
    <div class="button-header d-flex justify-content-end">
      <action-button
        i="fas fa-arrow-circle-left"
        :responsive="false"
        variant="outline-success m-1"
        @click="goBack"
      >
        Regresar
      </action-button>
      <action-button
        v-if="
          hasUnconfirmedSamplePrevisualizationData &&
            isValidArea &&
            !isConfirming
        "
        i="fas fa-times-circle"
        :responsive="false"
        variant="outline-danger m-1"
        @click="declineSample"
      >
        Rechazar
      </action-button>
      <action-button
        v-if="
          hasUnconfirmedSamplePrevisualizationData &&
            isValidArea &&
            !isConfirming
        "
        i="fas fa-check"
        :responsive="false"
        variant="success m-1"
        @click="confirmSample"
      >
        Confirmar
      </action-button>
    </div>
    <div class="col-12 mx-auto my-2">
      <div class="dropdown-divider" />
    </div>
    <div class="questionnaire-collapse mx-auto">
      <div class="row mx-auto col-12">
        <icon-view
          class="mt-md-0 mt-sm-5"
          gradient
          icon="fas fa-clipboard-list-check d-flex mb-1"
          icon-background="#ff7058"
          icon-color="#fff"
          icon-size="14px"
          :title="`Tabla de Cuestionario ${academicYearName || ''}`"
        />
      </div>
      <div
        v-if="isEvaluationTherapiesArea"
        class="evaluation-therapies-wrapper"
      >
        <div class="family-evaluation-sample col-12 my-3 mt-4">
          <questionnaire-collapse
            :key="`family-evaluation-sample-${keyIndex}`"
            :sample-type="sampleTypes.FamilyEvaluation"
            title="Familia - Evaluación"
          />
        </div>
        <div class="family-therapy-sample col-12 my-3">
          <questionnaire-collapse
            :key="`family-therapy-sample-${keyIndex}`"
            :sample-type="sampleTypes.FamilyTherapy"
            title="Familia - Terapias"
          />
        </div>
        <div class="teacher-sample col-12 my-3">
          <questionnaire-collapse
            :key="`teacher-sample-${keyIndex}`"
            is-teacher
            :sample-type="sampleTypes.FamilyTherapy"
            title="Maestros"
          />
        </div>
      </div>
      <div v-if="isTransportationArea" class="transportation-wrapper">
        <div class="transportation-general-sample col-12 my-3">
          <questionnaire-collapse
            :key="`transportation-general-${keyIndex}`"
            :academic-year-id="academicYearId"
            :area-id="transportationAreaId"
            :period-number="periodNumber"
            :sample-type="null"
            title="Familia - Transportación"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//libs
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import QuestionnaireCollapse from './components/QuestionnaireCollapse.vue';
import alertMixin from 'utils/mixins/alert.mixin';
import storeMixin from 'utils/mixins/storeGenerator';
import { questionnaireSampleType } from '@/utils/constants/questionnaireSampleType.js';
import {
  getSampleLog as _getSampleLog,
  restoreSamplePrevisualization as _restoreSamplePrevisualization,
  createSampleDetailsFromPrevisualization as _createSampleDetailsFromPrevisualization,
  hasSamplePrevisualizationData as _hasSamplePrevisualizationData,
  setStatusForSampleLog as _setStatusForSampleLog,
} from '@/modules/serviceSatisfactionQuestionnaire/api.js';
import { questionnaireArea } from '@/utils/constants/questionnaireArea.js';

export default {
  name: 'SampleDetails',
  components: {
    ActionButton,
    IconView,
    QuestionnaireCollapse,
  },
  mixins: [alertMixin, storeMixin],
  data() {
    return {
      keyIndex: 0,
      sampleLog: null,
      hasUnconfirmedSamplePrevisualizationData: false,
    };
  },
  computed: {
    sampleTypes() {
      return questionnaireSampleType;
    },
    logId() {
      return isNaN(this.$route.query.sampleLogId)
        ? null
        : Number(this.$route.query.sampleLogId);
    },
    areaId() {
      return this.sampleLog?.areaId;
    },
    periodNumber() {
      return this.sampleLog?.periodNumber;
    },
    academicYearId() {
      return this.sampleLog?.academicYearId;
    },
    academicYearName() {
      return this.sampleLog?.academicYear;
    },
    isEvaluationTherapiesArea() {
      return this.areaId === questionnaireArea.EvaluationTherapy;
    },
    isTransportationArea() {
      return this.areaId === this.transportationAreaId;
    },
    transportationAreaId() {
      return questionnaireArea.Transportation;
    },
    isValidArea() {
      return (
        !!this.areaId && Object.values(questionnaireArea)?.includes(this.areaId)
      );
    },
    isRejecting() {
      return this.sampleLog?.isRejecting;
    },
    isConfirming() {
      return this.sampleLog?.isConfirming;
    },
  },
  async mounted() {
    await this.getSampleLog();
    await this.loadHasUnconfirmedData();
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'ServiceSatisfactionQuestionnaire' });
    },
    async declineSample() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro(a) que desea rechazar la muestra para el proceso de completar los cuestionarios de satisfacción de servicios?',
        'Si',
        'No'
      );
      if (!answer) return;

      if (this.isRejecting) {
        this.ShowToast(
          'Error',
          'Existe un proceso de rechazo corriendo.',
          'error'
        );
        return;
      }

      await _setStatusForSampleLog({ id: this.logId, isRejecting: true });

      const restorePayload = {
        areaId: this.areaId,
        academicYearId: this.academicYearId,
        periodNumber: this.periodNumber,
      };

      await _restoreSamplePrevisualization(restorePayload);

      await this.getSampleLog();

      this.keyIndex++;
      this.$router.push({ name: 'ServiceSatisfactionQuestionnaire' });

      this.ShowToast(
        'Proceso Exitoso',
        'La muestra ha sido rechazada exitosamente.',
        'success'
      );
    },
    async confirmSample() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro(a) que desea crear la muestra para el proceso de completar los cuestionarios de satisfacción de servicios?',
        'Si',
        'No'
      );
      if (!answer) return;

      if (this.isRejecting) {
        this.ShowToast(
          'Error',
          'Existe un proceso de rechazo corriendo.',
          'error'
        );
        return;
      }

      if (!this.academicYearId) {
        this.ShowToast(
          '',
          'No es posible confirmar la muestra para el año académico y el periodo seleccionado ya que no cuenta con datos disponibles en el sistema.',
          'error'
        );
        return;
      }

      try {
        await _createSampleDetailsFromPrevisualization({
          academicYearId: this.academicYearId,
          periodNumber: this.periodNumber,
          areaId: this.areaId,
        });
        this.ShowToast(
          'Proceso Exitoso',
          'Se envió la confirmación de la creación de la muestra exitosamente, esto puede tardar varios minutos, puede regresar más tarde para ver el detalle de la muestra.',
          'success'
        );
        this.hasUnconfirmedSamplePrevisualizationData = false;
      } catch (error) {
        this.ShowToast(
          '',
          error.response.data.message || error.message,
          'error'
        );
      }
    },
    async getSampleLog() {
      const { data } = await _getSampleLog({ id: this.logId });
      this.sampleLog = { ...data };
    },
    async loadHasUnconfirmedData() {
      const { data: hasUnconfirmedData } = await _hasSamplePrevisualizationData(
        {
          academicYearId: this.academicYearId,
          periodNumber: this.periodNumber,
          areaId: this.areaId,
          onlyUnconfirmed: true,
        }
      );
      this.hasUnconfirmedSamplePrevisualizationData = hasUnconfirmedData;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .icon-font-22 {
  .font-16 {
    font-size: 20px !important;
  }
}
</style>
